jQuery(window).on('load', function () {
  
})
